import './NewPerson.scss';
import { Stepper } from './Stepper/Stepper';
import { useNewPersonVM } from './useNewPersonVM';
import { NewPersonFirstStep } from './NewPersonSteps/NewPersonFirstStep';
import { NewPersonSecondStep } from './NewPersonSteps/NewPersonSecondStep';
import { NewPersonThirdStep } from './NewPersonSteps/NewPersonThirdStep';
import { Loader } from 'components/Loader/Loader';
export const NewPerson: React.FC = () => {
    const {
        activeStep,
        steps,
        isQuickAdd,
        setIsQuickAdd,
        handleQuickCreatePerson,
        handleCreatePerson,
        handleNextStep,
        isSuccess,
        person,
        setActiveStep,
        handlePreviousStep,
        users
    } = useNewPersonVM();

    return (
        <div className="new-person">
            {!isQuickAdd && <Stepper activeStep={activeStep} steps={steps} setActiveStep={setActiveStep} handlePreviousStep={handlePreviousStep} />}
            {activeStep === 1 && (
                <NewPersonFirstStep
                    isQuickAdd={isQuickAdd}
                    person={person}
                    users={users}
                    setIsQuickAdd={setIsQuickAdd}
                    handleQuickCreatePerson={handleQuickCreatePerson}
                    handleNextStep={handleNextStep}
                    isSuccess={isSuccess}
                />
            )}
            {activeStep === 2 && (
                <NewPersonSecondStep
                    handleNextStep={handleNextStep}
                    person={person}
                    handlePreviousStep={handlePreviousStep}
                    setActiveStep={setActiveStep}
                />
            )}
            {activeStep === 3 && (
                <NewPersonThirdStep
                    handlePreviousStep={handlePreviousStep}
                    setActiveStep={setActiveStep}
                    person={person}
                    handleCreatePerson={handleCreatePerson}
                    isSuccess={isSuccess}
                />
            )}
        </div>
    );
};
